import {
  MODULE_ROOT_PATHS,
  PATHS,
  WELL_GUARDIAN_PATHS,
  WELL_GUARDIAN_ROOT_PATHS,
  WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS,
} from 'constants/paths';
import { isNotNullNorUndefined } from 'helpers/ts-helpers';
import { matchPath } from 'react-router-dom';

export type ToolbarTab = {
  icon?: React.ReactElement;
  label?: string;
  to: string;
  title?: string;
};

export const WELL_HEALTH_TABS: ToolbarTab[] = [
  {
    label: 'wellGuardian.header.menus.overview',
    to: PATHS.WELL_GUARDIAN_WELL_SINGLE_OVERVIEW,
    title: 'wellGuardian.header.title.overview',
  },
  {
    label: 'wellGuardian.header.menus.wellReviews',
    to: PATHS.WELL_GUARDIAN_WELL_WELL_REVIEWS,
    title: 'wellGuardian.header.title.wellReviews',
  },
  {
    label: 'wellGuardian.header.menus.schematics',
    to: PATHS.WELL_GUARDIAN_WELL_SINGLE_SCHEMATIC,
    title: 'wellGuardian.header.title.schematics',
  },
  {
    label: 'wellGuardian.header.menus.charts',
    to: PATHS.WELL_GUARDIAN_WELL_SINGLE_CHARTS,
    title: 'wellGuardian.header.title.charts',
  },
  {
    label: 'wellGuardian.header.menus.behaviour',
    to: PATHS.WELL_GUARDIAN_WELL_BEHAVIOUR,
    title: 'wellGuardian.header.title.behaviour',
  },
  {
    label: 'wellGuardian.header.menus.integrityDetails',
    to: PATHS.WELL_GUARDIAN_INTEGRITY_DETAILS,
    title: 'wellGuardian.header.title.integrityDetails',
  },
  {
    label: 'wellGuardian.header.menus.resources',
    to: PATHS.WELL_GUARDIAN_WELL_RESOURCES,
    title: 'wellGuardian.header.title.resources',
  },
];

export const getIsWellHealthSubModule = (path: string) =>
  Object.values(WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS).some(
    whPath =>
      !!matchPath(
        path,
        `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${whPath}`,
      ),
  );

export const getIsWellHealthAllWells = (path: string) =>
  !!matchPath(path, {
    path: WELL_GUARDIAN_PATHS.WELL_GUARDIAN_WELL_HEALTH_HOME,
    exact: true,
  });

export const getIsWellHealthAllWellsAlerts = (path: string) =>
  !!matchPath(path, {
    path: WELL_GUARDIAN_PATHS.WELL_GUARDIAN_MULTIPLE_WELLS_ALERTS,
    exact: true,
  });

export const getIsInterventionsWirList = (path: string) =>
  !!matchPath(path, {
    path: WELL_GUARDIAN_PATHS.WELL_GUARDIAN_INTERVENTIONS,
    exact: true,
  });

export const getIsInterventionsWirCreation = (path: string) =>
  !!matchPath(path, {
    path: WELL_GUARDIAN_PATHS.WELL_GUARDIAN_WIR_CREATION,
    exact: true,
  });

export const getIsDerogations = (path: string) =>
  !!matchPath(path, {
    path: WELL_GUARDIAN_PATHS.WELL_GUARDIAN_DEROGATIONS,
    exact: true,
  });

export const getIsSynergiCases = (path: string) =>
  !!matchPath(path, {
    path: WELL_GUARDIAN_PATHS.WELL_GUARDIAN_SYNERGI_CASES,
    exact: true,
  });

export const getIsInterventionsSubModule = (path: string) =>
  isNotNullNorUndefined(
    matchPath(path, {
      path: WELL_GUARDIAN_PATHS.WELL_GUARDIAN_INTERVENTIONS,
    }),
  );
